import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLines, FadeUp } from "@/components/Reveal";

const PageHero = ({ eyebrow, titleLines, description, image, children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "28%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.05, 1.2]);

  return (
    <section ref={ref} className="relative flex min-h-[72vh] items-end overflow-hidden pt-36 pb-20">
      <motion.div className="absolute inset-0" style={{ y, scale }}>
        <img src={image} alt="" className="h-full w-full object-cover" />
      </motion.div>
      <div className="hero-vignette absolute inset-0" />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 lg:px-10">
        {eyebrow && (
          <FadeUp>
            <p className="mb-5 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-gold-300">
              <span className="inline-block h-px w-10 bg-gold-300" />
              {eyebrow}
            </p>
          </FadeUp>
        )}
        <MaskedLines
          lines={titleLines}
          className="font-display text-5xl font-bold tracking-tight text-white sm:text-6xl lg:text-7xl"
          delay={0.1}
        />
        {description && (
          <FadeUp delay={0.45}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/80 md:text-lg">{description}</p>
          </FadeUp>
        )}
        {children}
      </div>
    </section>
  );
};

export default PageHero;
